<template>
  <div id="link">
    <div class="fullpage-container">
      <div class="fullpage-wp" v-fullpage="opts" ref="example">
        <section id="link-1" class="page">
          <div class="section container">
            <div class="title">
              <h1>在地連結</h1>
              <div class="title_underline"></div>
            </div>
            <div class="section_title animated fadeInLeft">
              中平路故事館
            </div>
            <div class="content">
              <div class="row">
                <div class="col-sm-4">
                  <img src="../assets/images/link-1.png" alt="" class="img-fluid">
                </div>
                <div class="col-sm-8">
                  <p>
                    中平路故事館是一棟充滿歷史韻味的日式雙併建築，興建於1930年，原為桃園縣政府公務員眷屬宿舍，佔地約30多坪，過去由曾任山地課課長的王國治先生與教育局的廖運全先生陸續入住，兩家四代在此度過了近一甲子的生活歲月，也見證了中壢區半個世紀以來的發展過程。
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section id="link-2" class="page">
          <div class="section container">
            <div class="content">
              <p>
                在2010年，中平路故事館被列為歷史建築，為了讓老屋活化再利用，桃園市政府文化局於2013年開始進行空間修繕，整修近2年的時間，直到2015年5月才以「中平路故事館」的新面貌開館營業，成為桃園市第一座「城市故事館」。
              </p>
              <p>
                延伸介紹：<a href="https://www.ahataoyuan.org/sub-category/YMNEdnpxj0" target="_blank">https://www.ahataoyuan.org/sub-category/YMNEdnpxj0</a>
              </p>
              <a href="https://drive.google.com/open?id=1CnbUVbhXktpv66Usg6Us1j0XQXnz8r3x&usp=sharing" target="_blank">地圖連結</a>
            </div>
          </div>
        </section>
        <section id="link-3" class="page">
          <div class="section container">
            <div class="section_title animated">
              中壢警察局
            </div>
            <div class="content">
              <div class="row">
                <div class="col-sm-4">
                  <img src="../assets/images/link-2.png" alt="" class="img-fluid">
                </div>
                <div class="col-sm-8">
                  <p>
                    1950年10月成立，是1977年中壢事件的主要發生地，中壢事件被認為是臺灣民眾第一次自發性地上街頭抗議選舉舞弊，開啟爾後「街頭運動」之序幕。
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section id="link-4" class="page">
          <div class="section container">
            <div class="content">
              <p>
                警察局對面有一日式宿舍群，建於日治時代1941年，當年日本政府透過保甲聯合會向居民募款興建，提供中壢郡役所的警察居住。中壢警察局日式宿舍群修復後也將設置「中壢事件紀念館」，讓更多民眾了解台灣民主化的歷程。
              </p>
              <p>
                延伸介紹：<a href="https://www.ahataoyuan.org/sub-category/YMNEdnpxj0" target="_blank">https://www.ahataoyuan.org/sub-category/YMNEdnpxj0</a>
              </p>
              <a href="https://drive.google.com/open?id=1CnbUVbhXktpv66Usg6Us1j0XQXnz8r3x&usp=sharing" target="_blank">地圖連結</a>
            </div>
          </div>
        </section>
        <section id="link-5" class="page">
          <div class="section container">
            <div class="section_title animated">
              中壢國小日式宿舍群
            </div>
            <div class="content">
              <div class="row">
                <div class="col-sm-4">
                  <img src="../assets/images/link-3.png" alt="" class="img-fluid">
                </div>
                <div class="col-sm-8">
                  <p>
                    與建於1917年，具有百年歷史的中壢國小日式宿舍群，原本是日治時期中壢公學校的教師宿舍，特色為日式建築黑瓦與台式紅磚與紅瓦建築混合而成，未來將成為親子教育、閱讀與體驗的場所，並與中平路故事館、中壢警察局日式宿舍群成為「中壢城市故事館三部曲」，串起中壢文化廊道。
                  </p>
                  <p>
                    延伸介紹：<a href="https://www.ahataoyuan.org/sub-category/YMNEdnpxj0" target="_blank">https://www.ahataoyuan.org/sub-category/YMNEdnpxj0</a>
                  </p>
                  <a href="https://drive.google.com/open?id=1CnbUVbhXktpv66Usg6Us1j0XQXnz8r3x&usp=sharing" target="_blank">地圖連結</a>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section id="link-6" class="page">
          <div class="section container">
            <div class="section_title animated">
              老街溪河川教育中心
            </div>
            <div class="content">
              <div class="row">
                <div class="col-sm-4">
                  <img src="../assets/images/link-4.png" alt="" class="img-fluid">
                </div>
                <div class="col-sm-8">
                  <p>
                    老街溪沿岸是中壢最早開發的地區，後來因加蓋及汙水的破壞，讓老街溪奄奄一息，現在透過開蓋工程，已讓老街溪重見光明。而老街溪河川教育中心於2011年6月5日成立，是全國第一個以「河川」為主題的教育中心，由原有兩棟客家古厝改建而成，該建築位於老街溪畔，見證老街溪河川整治過程。
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section id="link-7" class="page">
          <div class="section container">
            <div class="content">
              <p>
                主要介紹有關老街溪的河川整治過程、河川生態等資料，入口處有四座時光隧道滑梯，供孩童們遊玩。透過緊鄰老街溪的地理空間及老厝建築的歷史營造，做為大眾溯源尋根的文史基地、探索河川的體驗場域。
              </p>
              <a href="https://drive.google.com/open?id=1CnbUVbhXktpv66Usg6Us1j0XQXnz8r3x&usp=sharing" target="_blank">地圖連結</a>
            </div>
          </div>
        </section>
        <section id="link-8" class="page">
          <div class="section container">
            <div class="section_title animated">
              前中壢醫院
            </div>
            <div class="content">
              <div class="row">
                <div class="col-sm-4">
                  <img src="../assets/images/link-5.png" alt="" class="img-fluid">
                </div>
                <div class="col-sm-8">
                  <p>
                    中壢地區最具代表性的日據時期建築，建立於1921年，前身是由畢業於台北醫學專門學校的吳鴻森所創之中壢醫院，也曾作為桃園吳氏宗親會所用。建築本身設計單純、線條簡單，搭配洋式開窗，跳脫傳統巴洛克式的繁複裝飾，表現出帶有現代感的典雅風格，外觀可供民眾自由參觀，內部現則作為私人用途。
                  </p>
                  <a href="https://drive.google.com/open?id=1CnbUVbhXktpv66Usg6Us1j0XQXnz8r3x&usp=sharing" target="_blank">地圖連結</a>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section id="link-9" class="page">
          <div class="section container">
            <div class="section_title animated">
              中壢圖書館/義士堂
            </div>
            <div class="content">
              <div class="row">
                <div class="col-sm-4">
                  <img src="../assets/images/link-6.png" alt="" class="img-fluid">
                </div>
                <div class="col-sm-8">
                  <p>
                    成立於1970年，館舍曾經過多次搬遷，現址於2011年1月28日正式啟用，位於中正公園，此處是民眾休憩、週末走跳的好去處。在1977年桃園縣長選舉時，中壢市立圖書館曾舉辦過公辦政見發表會。
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section id="link-10" class="page">
          <div class="section container">
            <div class="content">
              <p>
                公園內有一座「義士堂」，即中壢市萬善堂。此堂興建於清朝道光十五年（西元 1835 年），並歷經兩次修建成為如今的模樣，而帝冠式的屋頂、西洋式的殿柱，是昭和8年重修時的建築風格。
              </p>
              <a href="https://drive.google.com/open?id=1CnbUVbhXktpv66Usg6Us1j0XQXnz8r3x&usp=sharing" target="_blank">地圖連結</a>
            </div>
          </div>
        </section>
        <section id="link-11" class="page">
          <div class="section container">
            <div class="section_title animated">
              仁海宮
            </div>
            <div class="content">
              <div class="row">
                <div class="col-sm-4">
                  <img src="../assets/images/link-7.png" alt="" class="img-fluid">
                </div>
                <div class="col-sm-8">
                  <p>
                    仁海宮創建於清道光6年(西元1826年)，主祀媽祖，迄今已有170多年歷史，是中壢區最古老的廟宇，由於其守護新街，大家又稱它為新街廟。據當地耆老表示，清代的中壢僅新街這一帶築有城池，由於媽祖常顯神蹟，地靈人傑，許多趕赴科舉考試的秀才都會來新街居住，於是此處也成為當時文風鼎盛之地。
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section id="link-12" class="page">
          <div class="section container">
            <div class="content">
              <p>
                中壢因為客家人眾多，所以每年農曆七月二十日義民節時，中壢仁海宮與平鎮義民廟均會配合中元普渡盛會，舉辦熱鬧的民俗慶典活動。
              </p>
              <a href="https://drive.google.com/open?id=1CnbUVbhXktpv66Usg6Us1j0XQXnz8r3x&usp=sharing" target="_blank">地圖連結</a>
            </div>
          </div>
        </section>
        <section id="link-13" class="page">
          <div class="section container">
            <div class="section_title animated">
              聖蹟亭
            </div>
            <div class="content">
              <div class="row">
                <div class="col-sm-4">
                  <img src="../assets/images/link-7.png" alt="" class="img-fluid">
                </div>
                <div class="col-sm-8">
                  <p>
                    距離仁海宮廟旁50公尺遠的聖蹟亭，約建於晚清時期，後於日治時期昭和年間重建，因此融合當代「洗石子」建築特色，並有日治時期大正年間流行的巴洛克雕飾。這是傳統舊習中的「敬惜字紙」，只要是寫上文字的紙，便不能任意丟棄踐踏，即使是廢紙，也必須集中起來，送到專門焚燒字紙的「聖蹟亭」焚毀，可見先民對文字的敬重。
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section id="link-14" class="page">
          <div class="section container">
            <div class="content">
              <p>
                惜字亭雖非客家人獨有的建築，卻是客家人的文化代表。客家人對於教育的重視也轉變為對文字的尊重，在客家地區的廟宇中，廟埕皆會設置惜字亭。
              </p>
              <a href="https://drive.google.com/open?id=1CnbUVbhXktpv66Usg6Us1j0XQXnz8r3x&usp=sharing" target="_blank">地圖連結</a>
            </div>
          </div>
        </section>
      </div>
      <div class="pager">
        <a href="javascript:void(0);"
           v-for="btn in pageNum"
           :class="{active:index == btn - 1}"
           @click="moveTo(btn - 1)">
        </a>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Link',
    mounted: function () {
      this.$root.title = '在地連結';
    },
    data: function () {
      let self = this;

      return {
        index: 0,
        pageNum: 14,
        opts: {
          start: 0,
          beforeChange: function (ele, current, next) {
            self.index = next;
          },
          afterChange: function (ele, current) {
            self.index = current;
            $('.section_title').removeClass('fadeInLeft');
            $(ele).find('.section_title').addClass('fadeInLeft');
          },
        }
      }
    },
    methods: {
      moveTo: function (index) {
        this.$refs.example.$fullpage.moveTo(index, true);
      },
    },
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import "../assets/css/global";

  #link {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;

    h1 {
      width: 100%;
      background: url("../assets/link.svg") center center no-repeat;
      text-indent: 200%;
      overflow: hidden;
      white-space: nowrap;

      @include media-breakpoint-down(sm) {
        background-position: left center;
      }
    }

    .content {
      img {
        @include media-breakpoint-down(sm) {
          padding: 0 20px;
          margin: 20px 0;
        }
      }
    }
  }
</style>
